
import React, { useEffect, useState } from "react";
import Popup from "../ui/Popup";
import Menu from "../ui/Menu";
import { KBD } from "../utils/Keybindings";
import { listen } from "../hooks/Listener";

export const pref_types = [
    { value: "", label: "N/A"},
    { value: "E", label: "Eml" },
    { value: "T", label: "Txt" },
    { value: "C", label: "Cel" },
    { value: "H", label: "Hom" },
    { value: "W", label: "Wrk" },
]

export default function PreferenceType(props) {
        const { controller = "", callback = () => { }, value = "", route = "", data = {} } = props;
        const [selected, setSelected] = useState(pref_types.find(item => item.value === value)?.value || "E");

        const actions = [
            { key: KBD.ESCAPE, action: () => { callback(false) } },
            { key: KBD.ENTER, action: () => { callback(selected) } }
        ]
        
        useEffect(() => {
            const cleanup = listen(controller, route, actions, false, [KBD.ESCAPE, KBD.ENTER]);
            return cleanup;
        }, [actions])

        const menu = pref_types.map(item => {
            let _i = { ...item };
            _i.text = _i.label;
            _i.action = () => callback(_i.value);
            return _i;
        })
        
        return (
            <>
                <Popup 
                    title={"Contact via"} 
                    width={"auto"} 
                    callback={callback} 
                    component={
                    <>
                        <Menu 
                            controller={controller} 
                            height = {240}
                            keyName="value" 
                            route={route} 
                            menu={menu} 
                            selected={selected} 
                            setSelected={setSelected} 
                            callback={(e) => callback(e.value)} 
                        />
                        <div style={{textAlign: "initial", padding: 10}}>
                            Contact options
                            <div className="shim"/>
                            {data.email && <div>{data.email}</div>}
                            {data.phone && <div>{data.phone}</div>}
                        </div>
                    </>
                    } 
                />
            </>)
    }